<mat-card class="medicine-create-view">
    <mat-card-title>
        New medicine
        <span *ngIf="createdMedicine">
            - {{createdMedicine.name}}
        </span>
    </mat-card-title>
    <mat-stepper linear #stepper>
        <mat-step [editable]="creatingMedicineIsEditable" [stepControl]="medicineForm">
            <ng-template matStepLabel>New medicine active</ng-template>
            <form autocomplete="off" [formGroup]="medicineForm">
                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Name</mat-label>
                                <input required formControlName="name" type="text" matInput placeholder="Name">
                                <mat-error *ngIf="medicineForm.get('name')?.invalid">
                                    Name is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Barcode prefix</mat-label>
                                <input required formControlName="barcodePrefix" type="text" matInput
                                    placeholder="Barcode prefix">
                                <mat-error *ngIf="medicineForm.get('barcodePrefix')?.invalid">
                                    Barcode prefix is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Active ingredient</mat-label>
                                <input required formControlName="activeIngredient" type="text" matInput
                                    placeholder="Active ingredient">
                                <mat-error *ngIf="medicineForm.get('activeIngredient')?.invalid">
                                    Active ingredient is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Active ingredient nappy code</mat-label>
                                <input formControlName="activeIngredientNappyCode" type="text" matInput
                                    placeholder="Active ingredient nappy code">
                                <mat-error *ngIf="medicineForm.get('activeIngredientNappyCode')?.invalid">
                                    Active ingredient nappy code is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                </div>

                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Schedule status</mat-label>
                        <mat-select required formControlName="scheduleStatus">
                            <mat-option *ngFor="let status of scheduleStatuses" [value]="status">
                                {{status}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="medicineForm.get('scheduleStatus')?.invalid">
                            Schedule status is invalid
                        </mat-error>
                    </mat-form-field>
                </p>

                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Description</mat-label>
                        <textarea required formControlName="description" matInput placeholder="Description"></textarea>
                        <mat-error *ngIf="medicineForm.get('description')?.invalid">
                            Description is invalid
                        </mat-error>
                    </mat-form-field>
                </p>
                
                <p>
                    <mat-checkbox formControlName="canOrder" color="primary">Can be Ordered</mat-checkbox>
                </p>
                
            </form>
            <div class="text-end mt-2">
                <button [disabled]="!medicineForm.valid" (click)="createMedicine()" mat-raised-button color="primary">
                    <mat-icon>chevron_right</mat-icon> Next
                </button>
            </div>
        </mat-step>
        <mat-step [editable]="creatingMedicineDosageTypeIsEditable" [stepControl]="medicineDosageTypeForm">
            <ng-template matStepLabel>Medicine active dosage type</ng-template>
            <form autocomplete="off" [formGroup]="medicineDosageTypeForm">
                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Type</mat-label>
                                <mat-select required formControlName="dosageType">
                                    <mat-option *ngFor="let type of dosageTypes" [value]="type">
                                        {{type.type}}
                                    </mat-option>
                                </mat-select>
                                <button type="button" matSuffix mat-icon-button (click)="createDosageType($event)">
                                    <mat-icon>add</mat-icon>
                                </button>
                                <mat-error *ngIf="medicineDosageTypeForm.get('dosageType')?.invalid">
                                    Dosage type is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Display name</mat-label>
                                <input required type="text" formControlName="additionalInformation" matInput
                                    placeholder="Display name">
                                <mat-error *ngIf="medicineDosageTypeForm.get('additionalInformation')?.invalid">
                                    Display name is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>

                    <div class="col-md-6">
                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Strength</mat-label>
                                <input required formControlName="dosageStrength" type="text" matInput
                                    placeholder="Strength">
                                <mat-error *ngIf="medicineDosageTypeForm.get('dosageStrength')?.invalid">
                                    Strength is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Active</mat-label>
                                <mat-select formControlName="isActive">
                                    <mat-option [value]="true">Yes</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                                <mat-error *ngIf="medicineDosageTypeForm.get('isActive')?.invalid">
                                    Active is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                </div>

                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Usage instructions</mat-label>
                        <textarea required formControlName="usageInstructions" matInput
                            placeholder="Usage instructions"></textarea>
                        <mat-error *ngIf="medicineDosageTypeForm.get('usageInstructions')?.invalid">
                            Usage instructions is invalid
                        </mat-error>
                    </mat-form-field>
                </p>

                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Storage directions</mat-label>
                        <textarea required formControlName="storageDirections" matInput
                            placeholder="Storage directions"></textarea>
                        <mat-error *ngIf="medicineDosageTypeForm.get('storageDirections')?.invalid">
                            Storage directions is invalid
                        </mat-error>
                    </mat-form-field>
                </p>

                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Special instructions</mat-label>
                        <textarea formControlName="specialInstructions" matInput
                            placeholder="Special instructions"></textarea>
                        <mat-error *ngIf="medicineDosageTypeForm.get('specialInstructions')?.invalid">
                            Special instructions is invalid
                        </mat-error>
                    </mat-form-field>
                </p>

            </form>
            <div class="text-end mt-2">
                <button mat-raised-button class="me-2" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon> Back
                </button>
                <button mat-raised-button [disabled]="!medicineDosageTypeForm.valid" color="primary"
                    (click)="createMedicineDosageType()">
                    <mat-icon>chevron_right</mat-icon> Next
                </button>
            </div>
        </mat-step>
        <mat-step [stepControl]="medicineDosagePackageTypeForm">
            <ng-template matStepLabel>Medicine package types</ng-template>
            <form [formGroup]="medicineDosagePackageTypeForm">
                <div class="row">

                    <p class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Label name</mat-label>
                            <input required formControlName="labelName" placeholder="Label name" type="text" matInput>
                            <mat-error *ngIf="medicineDosagePackageTypeForm.get('labelName')?.invalid">
                                Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
                            </mat-error>
                            <mat-hint>Maximum of 25 characters</mat-hint>
                        </mat-form-field>
                    </p>

                    <p class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Price</mat-label>
                            <input required formControlName="price" placeholder="Price" type="number" matInput>
                            <mat-error *ngIf="medicineDosagePackageTypeForm.get('price')?.invalid">
                                Price is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>

                    <p class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Package type</mat-label>
                            <mat-select required formControlName="packageType">
                                <mat-option *ngFor="let type of packageTypes" [value]="type">
                                    {{type.type}}
                                </mat-option>
                            </mat-select>
                            <button type="button" matSuffix mat-icon-button (click)="createPackageType($event)">
                                <mat-icon>add</mat-icon>
                            </button>
                            <mat-error *ngIf="medicineDosagePackageTypeForm.get('packageType')?.invalid">
                                Package type is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>

                    <p class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Quantity</mat-label>
                            <input required formControlName="containedQuantity" placeholder="Quantity" type="number" step="0.01"
                                matInput>
                            <span matSuffix>{{currentDosageUnit ? currentDosageUnit.unit : "-"}}</span>
                            <mat-error *ngIf="medicineDosagePackageTypeForm.get('containedQuantity')?.invalid">
                                Quantity is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>

                </div>
            </form>

            <button mat-stroked-button [disabled]="!medicineDosagePackageTypeForm.valid"
                (click)="createMedicineDosagePackageType()">
                <mat-icon>add</mat-icon> Add package type
            </button>

            <!--List out the package types :)-->
            <core-medicine-dosage-package-type-list [dosageUnit]="currentDosageUnit" (onUpdated)="onDosagePackageTypesUpdated($event)"
                *ngIf="createdMedicineDosageType && createdMedicine"
                [medicineDosageTypeId]="createdMedicineDosageType.id" [packageTypes]="packageTypes"
                [medicineId]="createdMedicine.id" [medicineDosagePackageTypes]="medicineDosagePackageTypes">
            </core-medicine-dosage-package-type-list>
            <div class="text-end mt-2">
                <button mat-raised-button (click)="redirect()" color="primary">
                    <mat-icon>done</mat-icon> Done
                </button>
            </div>
        </mat-step>
    </mat-stepper>
</mat-card>